import { render, staticRenderFns } from "./SimpleCarousel.vue?vue&type=template&id=491aea72&lang=pug"
import script from "./SimpleCarousel.vue?vue&type=script&lang=js"
export * from "./SimpleCarousel.vue?vue&type=script&lang=js"
import style0 from "./SimpleCarousel.vue?vue&type=style&index=0&id=491aea72&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports